/** Text completion prompts */

import songImage from './song-image.js'
import songLine from './song-line.js'
import songMelodySuggestions from './song-melody-suggestions.js'
import songMusic from './song-music.js'
import songSection from './song-section.js'

export const CompletionPrompts = {
  songSection,
  songLine,
  songImage,
  songMusic,
  songMelodySuggestions,
}

export type { MelodyChordRef, MelodySuggestionPromptInput } from './song-melody-suggestions.js'
